import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

import { Size } from './types';

export const InputContainer = styled.div`
  position: relative;
`;

export const Button = styled.button<{
  $isPlaceholder: boolean;
  $noBorders: boolean;
  $size: Size;
  $inheritColor: boolean;
  $noOverflow: boolean;
}>`
  ${({ theme, $size }) =>
    typographyToCss(
      [Size.ExtraSmall, Size.Small].includes($size)
        ? theme.typography.body2
        : theme.typography.body2,
    )};

  margin: 0;
  padding: ${({ theme, $size }) =>
    $size === Size.ExtraSmall
      ? `${theme.spacing(1)} ${theme.spacing(6.5)} ${theme.spacing(1)} ${theme.spacing(2)}`
      : `${theme.spacing(1.5)} ${theme.spacing(8)} ${theme.spacing(1.5)} ${theme.spacing(2)}`};
  width: 100%;

  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  box-shadow: ${({ theme }) => theme.shadowBox.select};
  border: ${({ theme, $noBorders }) =>
    $noBorders ? 'none' : `1px solid ${theme.palette.grey[400]}`};

  color: ${({ theme, $inheritColor }) =>
    $inheritColor ? 'inherit' : theme.palette.text.primary};
  text-align: left;
  cursor: pointer;

  ${({ $noOverflow }) =>
    $noOverflow &&
    css`
      overflow: hidden;

      text-overflow: ellipsis;
      white-space: nowrap;
    `};

  ${({ $isPlaceholder, theme }) =>
    $isPlaceholder &&
    css`
      color: ${theme.palette.text.secondary};
    `};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) =>
        `${theme.spacing(2.5)} ${theme.spacing(8)} ${theme.spacing(2.5)} ${theme.spacing(3)}`};
    `};
`;

export const InteractionContainer = styled.div<{
  $inheritColor: boolean;
  $size: Size;
}>`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing(2)};

  transform: translateY(-50%);

  color: ${({ theme, $inheritColor }) =>
    $inheritColor ? 'inherit' : theme.palette.text.primary};
  line-height: 62.5%;

  ${({ $size }) =>
    $size === Size.ExtraSmall &&
    css`
      font-size: 1.2rem;
    `}
`;

export const IconContainer = styled.span`
  display: block;
  transform: rotate(-90deg);
  font-size: inherit;
  line-height: 62.5%;
  cursor: pointer;
`;

export const ClearButton = styled.button`
  margin: 0;
  padding: 0;

  border: none;
  background: none;
  cursor: pointer;

  color: inherit;
  font-size: inherit;
  line-height: 62.5%;
`;
